import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProblemOutcome from './components/ProblemOutcome';
import WhatWeDo from './components/WhatWeDo';
import HowItWorks from './components/HowItWorks';
import Industries from './components/Industries';
import ClientStories from './components/ClientStories';
import WhyAnnalogix from './components/WhyAnnalogix';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative">
      <Header scrolled={scrolled} />
      <Hero />
      <ProblemOutcome />
      <WhatWeDo />
      <HowItWorks />
      <Industries />
      <ClientStories />
      <WhyAnnalogix />
      <CallToAction />
      <Footer />
    </div>
  );
}
